import { UserType, UserTypeExtensions } from "../embed/user-type";

export enum RoleTypeCode {
    Leader = "LEADER",
    Collaborator = "COLLABORATOR",
    Viewer = "VIEWER",
    Owner = "OWNER",
    Leadership = "LEADERSHIP",
    Other = "OTHER",
    TeamInput = "TEAMINPUT",                    // system role but assignable via team roles
    CulturalLeader = "CULTURALLEADER",          // system role - can edit description
    TeamLeader = "TEAMLEADER",                  // system role
    TeamMember = "TEAMMEMBER",                  // system role
    TeamParticipant = "TEAMPARTICIPANT",        // system role
    Coach = "COACH",                            // system role
    OwnerMentor = "OWNERMENTOR",                // system role
}

export const AssignableRoleTypes = [RoleTypeCode.Owner, RoleTypeCode.Leadership, RoleTypeCode.Other];
export const CoachRoleTypes = [RoleTypeCode.Coach, RoleTypeCode.OwnerMentor];

export const CoachTypes = [
    { text: "Adapt Build Coach", value: RoleTypeCode.Coach },
    { text: "Adapt Design Coach", value: RoleTypeCode.OwnerMentor },
];

export class RoleTypeCodeLabel {
    public static label(code?: RoleTypeCode) {
        if (!code) {
            return "";
        }

        switch (code) {
            case RoleTypeCode.Owner:
                return "Owner";
            case RoleTypeCode.Leader:
            case RoleTypeCode.CulturalLeader:
            case RoleTypeCode.Leadership:
                return "Leadership";
            case RoleTypeCode.Other:
                return "Other";
            case RoleTypeCode.Collaborator:
                return UserTypeExtensions.pluralLabel(UserType.Collaborator);
            case RoleTypeCode.Viewer:
                return UserTypeExtensions.pluralLabel(UserType.Viewer);
            case RoleTypeCode.Coach:
            case RoleTypeCode.OwnerMentor:
                return UserTypeExtensions.singularLabel(UserType.Coach);
            default:
                throw new Error(`Unknown role type code "${code}" (1)`);
        }
    }

    public static accessLevelLabel(code?: RoleTypeCode) {
        if (!code) {
            return "";
        }

        switch (code) {
            // not used for access levels (manage access page)
            case RoleTypeCode.Owner:
            case RoleTypeCode.Leadership:
            case RoleTypeCode.Other:
                return "N/A";
            case RoleTypeCode.Leader:
            case RoleTypeCode.CulturalLeader:
                return UserTypeExtensions.pluralLabel(UserType.Leader);
            case RoleTypeCode.Collaborator:
                return UserTypeExtensions.pluralLabel(UserType.Collaborator);
            case RoleTypeCode.Viewer:
                return UserTypeExtensions.pluralLabel(UserType.Viewer);
            case RoleTypeCode.Coach:
            case RoleTypeCode.OwnerMentor:
                return UserTypeExtensions.pluralLabel(UserType.Coach);
            default:
                throw new Error(`Unknown role type code "${code}" (1)`);
        }
    }

    public static ordinal(code?: RoleTypeCode) {
        if (!code) {
            return 99;
        }

        switch (code) {
            case RoleTypeCode.Leader:
            case RoleTypeCode.CulturalLeader:
            case RoleTypeCode.Leadership:
                return 0;
            case RoleTypeCode.Other:
                return 1;
            case RoleTypeCode.Owner:
                return 2;
            case RoleTypeCode.Collaborator:
                return 3;
            case RoleTypeCode.Viewer:
                return 4;
            case RoleTypeCode.Coach:
            case RoleTypeCode.OwnerMentor:
                return 5;
            default:
                throw new Error(`Unknown role type code "${code}" (2)`);
        }
    }
}
